<template>
  <span>{{ display }}</span>
</template>

<script>
// Ersetzt Berts wg_startCounter (jQuery animate): zählt eine Zahl hoch, sobald
// das Element in den Viewport scrollt. Deutsche Formatierung (1.000er-Punkt)
// über toLocaleString('de-DE'). Gemountet auf [data-vue-countup]; Props kommen
// aus data-Attributen des Mount-Elements:
//   data-target   (Pflicht, Zahl ohne Tausenderpunkte)
//   data-duration (optional, ms, Default 2500)
//   data-prefix / data-suffix (optional)
//   data-grouping ("false" um Tausenderpunkte zu unterdrücken, z.B. Jahreszahlen)
export default {
  name: 'CountUp',
  props: {
    target: {
      type: Number,
      required: true,
    },
    duration: {
      type: Number,
      default: 2500,
    },
    prefix: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
    // Bert formatiert nur Zahlen mit Punkten im Quellwert mit Tausenderpunkten
    // (Jahreszahlen bleiben ungruppiert) — das bildet dieses Flag ab.
    grouping: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      current: 0,
      started: false,
      observer: null,
      rafId: null,
    }
  },
  computed: {
    display() {
      const value = Math.round(this.current)
      const formatted = this.grouping ? value.toLocaleString('de-DE') : String(value)
      return `${this.prefix}${formatted}${this.suffix}`
    },
  },
  mounted() {
    if (Number.isNaN(this.target)) {
      return
    }
    if (!('IntersectionObserver' in window)) {
      this.current = this.target
      return
    }
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.started) {
            this.started = true
            this.animate()
            this.observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.5 }
    )
    this.observer.observe(this.$el)
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect()
    }
    if (this.rafId) {
      cancelAnimationFrame(this.rafId)
    }
  },
  methods: {
    animate() {
      // rAF-Animation respektiert prefers-reduced-motion (die CSS-Media-Query
      // in base.css greift hier nicht) — direkt zum Zielwert springen.
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.current = this.target
        return
      }
      const start = performance.now()
      const step = (now) => {
        const progress = Math.min((now - start) / this.duration, 1)
        // jQuery-"swing"-Easing: 0.5 - cos(t * PI) / 2
        const eased = 0.5 - Math.cos(progress * Math.PI) / 2
        this.current = this.target * eased
        if (progress < 1) {
          this.rafId = requestAnimationFrame(step)
        } else {
          this.current = this.target
          this.rafId = null
        }
      }
      this.rafId = requestAnimationFrame(step)
    },
  },
}
</script>
